var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VCombobox',_vm._g(_vm._b({attrs:{"dense":"","label":"Banka Entegrasyon Anahtar Kelimeleri","multiple":"","chips":"","clearable":"","hide-details":"auto"}},'VCombobox',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }